"use strict";

import Vue from 'vue';
import axios from "axios";
const ProxyHandler = require('../services/proxy').default;

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    config.url = ProxyHandler.getProxiedUrl(config.url);
    return config;
  },
  function(error) {
    const newProxy = ProxyHandler.moveToNextProxy();
    if (_axios.onProxyChanged) {
      _axios.onProxyChanged(newProxy);
    }
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    const newProxy = ProxyHandler.moveToNextProxy();
    if (_axios.onProxyChanged) {
      _axios.onProxyChanged(newProxy);
    }
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue, ignoredOptions) {
  Vue.axios = _axios;
  window.axios = _axios;
  window.axiosType = axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
